"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickElement = void 0;
var ClickElement;
(function (ClickElement) {
    ClickElement["SearchHistoryDelete"] = "Search history delete";
    ClickElement["SearchMorePopularExperiences"] = "Search more popular experiences";
    ClickElement["SearchMoreLastSeenExperiences"] = "Search more last seen experiences";
    ClickElement["SearchMoreMatchingExperiences"] = "Search more matching experiences";
    ClickElement["MapInBuybox"] = "Map in buybox";
    ClickElement["TicketLocation"] = "Ticket location";
    ClickElement["TicketDate"] = "Ticket date";
    ClickElement["TicketTime"] = "Ticket time";
    ClickElement["TicketCount"] = "Ticket count";
    ClickElement["DeliveryCosts"] = "Delivery costs";
    ClickElement["AddToCart"] = "Add To Cart";
    ClickElement["WhatsApp"] = "Socialshare - WhatsApp";
    ClickElement["Link"] = "Socialshare - Link";
    ClickElement["EMail"] = "Socialshare - E-Mail";
    ClickElement["Close"] = "Socialshare - Close";
    ClickElement["PaybackInformation"] = "Payback Collect Information";
    ClickElement["PaybackAdditionalInformation"] = "Additional Information Payback";
    ClickElement["ProductInformation"] = "Product information";
    ClickElement["MapView"] = "Mapview";
    ClickElement["MapInDescription"] = "Map in description";
    ClickElement["PDPVariant"] = "PDP variant";
    ClickElement["SpvDate"] = "Spv Date";
    ClickElement["SpvTime"] = "Spv Time";
    ClickElement["ClickToCart"] = "Click To Cart";
    ClickElement["ClickToCancelDay"] = "Cancel Day Seletion";
    ClickElement["BackToProviderList"] = "Back To Provider List";
    ClickElement["LinkToPartnerChat"] = "Link To Partner Chat";
    ClickElement["LinkToDirectContact"] = "Link To Direct Contact";
    ClickElement["ButtonToAddVoucherToCart"] = "Button To Add Voucher To Cart";
    ClickElement["BackToPDP"] = "Back to PDP";
    ClickElement["ClickToBooking"] = "Click To Booking";
    ClickElement["OpenDetailsOfExperience"] = "Open Details Of Experience";
    ClickElement["PaginationNext"] = "Pagination Next";
    ClickElement["PaginationPrevious"] = "Pagination Previous";
    ClickElement["PaginationSelector"] = "Pagination Selector";
    ClickElement["SelectSpvOption"] = "Select Spv Option";
    ClickElement["EcomCTA"] = "EcomCTA";
    ClickElement["BookingLink"] = "Booking Link";
    ClickElement["MapInExperienceSelection"] = "Map In Experience Selection";
    ClickElement["ProceedToLastCheck"] = "proceed to last check";
    ClickElement["B2BLink"] = "b2b link";
    ClickElement["AddressCorrection"] = "address_correction";
    ClickElement["ExperienceCategories"] = "Erlebniskategorien";
    ClickElement["OpenBurgerNavigation"] = "open burger navigation";
    ClickElement["CloseBurgerNavigation"] = "close burger navigation";
    ClickElement["ChooseAlternativeExperienceForExistingVoucher"] = "Choose alternative experience for existing voucher";
    ClickElement["BuddyVoucherInfo"] = "Buddy voucher information popup";
    ClickElement["OpenQuantityDropdown"] = "Open quantity dropdown";
    ClickElement["LogIn"] = "Log In";
    ClickElement["SignUpConfirmationPage"] = "Sign-up confirmation page";
    ClickElement["OpenPromoBannerDescription"] = "open promotion banner description";
})(ClickElement || (exports.ClickElement = ClickElement = {}));
//# sourceMappingURL=ClickElement.js.map